import projects from "./projects";
import inWork from "./in-work";
import handled from "./handled";

import incomings from "./lists/incomings";
import outgoings from "./lists/outgoings";
import inners from "./lists/inners";
import dirords from "./lists/dirords";
import incomingActItems from "./lists/incoming-act-items";
import ords from "./lists/ords";
import innerActItems from "./lists/inner-act-items";
import favorites from "./lists/favorites";
import svetofor from "./lists/svetofor";
import completed from "./lists/completed";

const correspondence = {
    namespaced: true,
    state: {
        list: null
    },
    mutations: {
        SET_LIST (state, payload) {
            state.list = payload;
        },
    },
    getters: {
        getList: (s) => s.list
    },
    modules: {
        projects,
        inWork,
        handled,
        incomings,
        outgoings,
        inners,
        dirords,
        incomingActItems,
        ords,
        innerActItems,
        favorites,
        svetofor,
        completed
    }
}

export default correspondence;